const SearchSmall = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M18 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0zm-1.382 7.032a9 9 0 1 1 1.414-1.414l4.882 4.882-1.414 1.414-4.882-4.882z" fill="#000"></path>
    </svg>
)

export default SearchSmall;